import { render, staticRenderFns } from "./RouteHistory.vue?vue&type=template&id=f0233452&scoped=true&"
import script from "./RouteHistory.vue?vue&type=script&lang=ts&"
export * from "./RouteHistory.vue?vue&type=script&lang=ts&"
import style0 from "./RouteHistory.vue?vue&type=style&index=0&id=f0233452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0233452",
  null
  
)

export default component.exports